module.exports = __webpack_public_path__ + "static/img/1.8a215ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/eng/1.png
// module id = hWtb
// module chunks = 0